module.exports = __webpack_public_path__ + "static/media/Checklist.13c88297.svg";